import { useEffect } from 'react';

import { WindowEventType } from '@this+that/utils';

/**
 * Re-runs `refetch` whenever the window regains focus (returning from a
 * Stripe checkout tab/redirect is the main case here). Paired with the
 * query's own `pollInterval` for the steady-state refresh — see
 * useCreditsBalance/useTeamCreditsBalance.
 */
export function useRefetchOnWindowFocus(
  refetch: () => void,
  enabled: boolean,
): void {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const handleFocus = () => refetch();
    window.addEventListener(WindowEventType.FOCUS, handleFocus);
    return () => {
      window.removeEventListener(WindowEventType.FOCUS, handleFocus);
    };
  }, [enabled, refetch]);
}
